module.exports = __webpack_public_path__ + "img/backReportHeader.fe001ef5.png";